import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import { GOOGLE_AR_SUPPORTED_DEVICES_URL } from "../../constants/Constants";
import CenterModal from "../UI/Modal/CenterModal";

const MeasurementARStatusModal = ({ actionType, modalTitleKey, modalBodyKey, handleCloseModal, isARNotSupportedLink = false }) => {
    const localisedValues = useLanguageChange();

    const modalHeader = (
        <>
            <h5 className='modal-title'>{localisedValues[modalTitleKey]}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={handleCloseModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const modalBody = isARNotSupportedLink ? (
        <div className='cms-modal-text' data-testid='armeasurement-status-model'>
            <p>
                <span>{localisedValues[modalBodyKey]}</span>{" "}
                <a href={GOOGLE_AR_SUPPORTED_DEVICES_URL} target='_blank'>
                    {localisedValues["view_supported_device"]}
                </a>
            </p>
        </div>
    ) : (
        <div className='cms-modal-text'>
            <p>{localisedValues[modalBodyKey]}</p>
        </div>
    );

    const modalFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={() => handleCloseModal()}>
                    {localisedValues["dismiss"]}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={true}
            closeModal={() => handleCloseModal()}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={modalHeader}
            body={modalBody}
            footer={modalFooter}
            backdrop={"static"}
        />
    );
};

MeasurementARStatusModal.propTypes = {
    actionType: PropTypes.string,
    modalTitleKey: PropTypes.string,
    modalBodyKey: PropTypes.string,
    handleCloseModal: PropTypes.func,
    isARNotSupportedLink: PropTypes.bool,
};

export default MeasurementARStatusModal;
